export default class InvoiceTexts {
    static PLACEHOLDER_IBANBIC = 'IBANBIC';
    static PLACEHOLDERS = [
        {
            key: 'IBANBIC',
            example: 'DE89 3704 0044 0532 0130 00, COBADEFFXXX',
        },
        {
            key: 'MANDATSREFERENZ',
            example: 'MR-1234567890',
        },
        {
            key: 'GLÄUBIGERID',
            example: 'GID-DE-1234567890',
        },
    ];

    constructor() {
        this.generalText = '';
        this.generalDefaultText = '';
        this.bankTransferText = '';
        this.bankTransferDefaultText = '';
        this.cashText = '';
        this.cashDefaultText = '';
        this.cashBankAccountVisibility = false;
        this.indefiniteText = '';
        this.negativeAmountText = '';
        this.indefiniteDefaultText = '';
        this.negativeAmountDefaultText = '';
        this.indefiniteBankAccountVisibility = false;
        this.sepaDebitText = '';
        this.sepaDebitDefaultText = '';
        this.sepaDebitBankAccountVisibility = false;
        this.sepaDebitAnonymizedMemberIban = false;
        this.debitCardText = '';
        this.debitCardDefaultText = '';
        this.debitCardBankAccountVisibility = false;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const invoiceTexts = new InvoiceTexts();
        invoiceTexts.generalText = data.generalText;
        invoiceTexts.generalDefaultText = data.generalDefaultText;
        invoiceTexts.bankTransferText = data.bankTransferText;
        invoiceTexts.bankTransferDefaultText = data.bankTransferDefaultText;
        invoiceTexts.cashText = data.cashText;
        invoiceTexts.cashDefaultText = data.cashDefaultText;
        invoiceTexts.cashBankAccountVisibility = data.cashBankAccountVisibility;
        invoiceTexts.indefiniteText = data.indefiniteText;
        invoiceTexts.indefiniteDefaultText = data.indefiniteDefaultText;
        invoiceTexts.indefiniteBankAccountVisibility = data.indefiniteBankAccountVisibility;
        invoiceTexts.negativeAmountText = data.negativeAmountText;
        invoiceTexts.negativeAmountDefaultText = data.negativeAmountDefaultText;
        invoiceTexts.sepaDebitText = data.sepaDebitText;
        invoiceTexts.sepaDebitDefaultText = data.sepaDebitDefaultText;
        invoiceTexts.sepaDebitDefaultTextWithPlaceholders = data.sepaDebitDefaultTextWithPlaceholders;
        invoiceTexts.sepaDebitBankAccountVisibility = data.sepaDebitBankAccountVisibility;
        invoiceTexts.sepaDebitAnonymizedMemberIban = data.sepaDebitAnonymizedMemberIban;
        invoiceTexts.debitCardText = data.debitCardText;
        invoiceTexts.debitCardDefaultText = data.debitCardDefaultText;
        invoiceTexts.debitCardBankAccountVisibility = data.debitCardBankAccountVisibility;

        return invoiceTexts;
    }
}
